import { toast } from 'react-toastify'
import React from 'react'

const Body = ({ obj }) => (
    <div className={`wrap ${obj.title_only ? 'centered' : ''}`}>
        <div className="title">{obj.title}</div>
        {!obj.title_only ? <div className="msg">{obj.msg}</div> : null}
    </div>
)

const Toast = (type, obj) => {
    const options = {
        // autoClose: false,
        autoClose: obj.time || 4000,
        position: toast.POSITION.TOP_RIGHT,
        className: 'old-style',
    }

    toast[type](<Body obj={obj} />, options)
}

export default Toast
